/**
 * Same-origin backend proxy base URLs for Google Maps Platform.
 *
 * In production: Azure Functions managed SWA backend (/api/...).
 * In development: Vite development server proxy.
 *
 * All requests are executed server-to-server with GOOGLE_MAPS_SERVER_KEY.
 * The client browser never receives or exposes the Google API key in the UI query string.
 */
export const GOOGLE_PLACES_API_BASE =
  import.meta.env.VITE_GOOGLE_PLACES_API_BASE ?? "/api/google/places";

export const GOOGLE_MAPS_API_BASE =
  import.meta.env.VITE_GOOGLE_MAPS_API_BASE ?? "/api/google/maps";

